import { initBugsnag, KeepInView } from 'site/bootstrap';
import 'site/analytics';
import { TextCycle, Signup, HighlightMarkdownCode, WhoisForm } from 'site/pages';
import 'site/controllers';
import TurboInit from 'site/turbo-init';
import onReady from 'site/on-ready';
import Tooltip from 'components/tooltip/component';

// The marketing site's interactive elements are vanilla web components. They
// auto-upgrade whenever they enter the DOM (including Turbo body-swaps), so
// importing each one for its side-effecting customElements.define(...) is the
// only setup needed.

// One-time setup: these attach their listeners once and are unaffected by Turbo
// body-swaps (Tooltip/KeepInView use delegated document listeners; Bugsnag is a
// global).
TurboInit.ready();
Tooltip.ready();
KeepInView.init();
initBugsnag();

// Per-page initializers: run once per rendered page — on the initial
// DOMContentLoaded and again after every Turbo visit (onReady dedupes by body).
onReady(() => {
  WhoisForm.init();
  Tooltip.init();
  TextCycle.ready();
  Signup.ready();
  HighlightMarkdownCode.ready();
});
